
import { PermissionSet, User } from '../../../Models/User';
import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import LaunchIcon from '@mui/icons-material/Launch';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { AuthProps } from '../../../Services/AuthService';
import { ReactNode } from 'react';
import { useDrawer } from '../../Providers/DrawerProvider';
import NavigationMenu from '../../Controls/Layout/NavigationMenu/NavigationMenu';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { AppState } from '../../../Store/rootReducer';
import AccountCircle from '@mui/icons-material/AccountCircle';
// import HelpIcon from '@mui/icons-material/Help';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { userCanSwitchClients, userHasPermission } from '../../../Helpers/Utilities';
import { permissions } from '../../../Helpers/Constants';
import { Dealer } from '../../../Models/Dealer';
import ClientSwitcherDrawer from '../../Controls/ClientSwitcherDrawer/ClientSwitcherDrawer';
import styles from './_default-app-container.module.scss';
import { setSelectedClientId } from '../../../Store/PerformanceReport/actions';
import { loadLibrary } from '../../../Store/Library/actions';
import { Alert as MuiAlert, AlertTitle, Tooltip } from '@mui/material';
import { removeAlert } from '../../../Store/Notifications/actions';
import { Alert } from '../../../Models/Alert';
import { set } from 'ramda';
export interface DefaultAppContainerProps extends AuthProps {
  children: ReactNode;
  theme?: any;
}
function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: 0,
    width: `calc(100% - ${0}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: 0,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);


function DefaultAppContainer(props: DefaultAppContainerProps) {
  const currentUser = useSelector((state: AppState) => state.shared.currentUser)
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const dpgClients = useSelector((state: AppState) => state.library.dpgClients);
  const [isClientSwitcherDrawerOpen, setIsClientSwitcherDrawerOpen] = React.useState<boolean>(false);
  const isMenuOpen = Boolean(anchorEl);
  const selectedClientId = useSelector((state: AppState) => state.performanceReport.selectedClientId);
  const [openDrawer, closeDrawer] = useDrawer();
  const alerts = useSelector((state: AppState) => state.notifications.notifications);

  const dispatch = useDispatch();
  const onSelectionMade = () => {
    closeDrawer();
    setOpen(false);
  };
  const toggleDrawer = (isOpen: boolean) => {
    setOpen(!isOpen);
    if (isOpen) {
      closeDrawer();
    } else {
      openDrawer({
        children: <NavigationMenu user={currentUser} closeDrawer={onSelectionMade} />,
        className: 'leftDrawerContainer',
        variant: "temporary",
        anchor: "left",
        style: { marginTop: '12px' }
      });
    }
  };
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const mdTheme = createTheme(props.theme);
  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={() => setAnchorEl(null)}
    >
      <MenuItem onClick={props.authService.SignOut}>Sign Out</MenuItem>
    </Menu>
  );
  const selectedClient = dpgClients.find(c => c.id === selectedClientId);

  // Set the selected User to be the currently logged in users client if they don't have permissions to switch clients
  if(currentUser && !userHasPermission(currentUser, permissions.clients, PermissionSet.U) && !currentUser.isSuperUser 
    && currentUser.clientId && selectedClientId === null) { 
    dispatch(setSelectedClientId(currentUser.clientId));
  }
  return (
    // <ThemeProvider theme={mdTheme}>
    <>
      <Box className={styles.defaultAppContainer}>
        <CssBaseline />
          <div style={{ display: 'flex',  position: "relative", flex: 1, height: "60px", backgroundColor: '#333333', color: 'white', alignItems: 'center', padding: '0 24px' }}>

            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={() => toggleDrawer(open)}
              sx={{
                marginRight: "36px",
              }}
            >
              <>
                {!open && <MenuIcon />}
                {open && <ChevronLeftIcon />}
              </>
            </IconButton>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <img src='/assets/header-logo.png' alt='NIADA Dealer 20 Groups' style={{ height: '55px', width: 'auto' }} />
              {userCanSwitchClients(currentUser) && ( 
                <div style={{display: 'flex', alignItems: 'center'}}>
                  {selectedClient && (
                    <Typography variant='h6' style={{ color: '#d95137' }}>{selectedClient.name}</Typography>
                  )}
                  {!selectedClient && (
                    <Typography variant='h5' style={{ color: '#d95137' }}>{"Select Member"}</Typography>
                  )}
                  <IconButton
                    onClick={() => setIsClientSwitcherDrawerOpen(true)}
                  >
                    <LaunchIcon style={{color: 'white'}} />
                  </IconButton>
                  <ClientSwitcherDrawer
                    className={styles.clientSwitcher}
                    isOpen={isClientSwitcherDrawerOpen}
                    clients={dpgClients}
                    onSelectClient={(client: Dealer) => {
                      dispatch(setSelectedClientId(client.id));
                      dispatch(loadLibrary(client.id))
                      setIsClientSwitcherDrawerOpen(false)
                    }}
                    onClose={() => setIsClientSwitcherDrawerOpen(false)}
                  />
                </div>            
              )}
              {!userCanSwitchClients(currentUser) && (
                <Typography variant='h5' style={{ color: 'white' }}>{currentUser?.clientName}</Typography>
              )}
            </div>
            <Typography
              component="h1"
              variant="h5"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, marginLeft: '10px' }}
            >

            </Typography>
            {/* <Link
              variant="body2"
              href="mailto:helpdesk@amsanalytics.com?subject=NIADA Question"
            >
              <IconButton >
                <HelpIcon style={{ color: "white" }} />
              </IconButton>
            </Link> */}
           {true && (
              <Tooltip title='Help Desk'>
                <Link
                  to="/ticket"
                  target="_self"
                  component={RouterLink}
                >
                  <ContactSupportIcon
                    fontSize="medium"
                    style={{ color: "#ffffff", marginTop: "4px" }}
                  />
                </Link>
              </Tooltip>
            )}
            {currentUser && (
              <IconButton
                edge='end'
                aria-label='account of current user'
                aria-controls={menuId}
                aria-haspopup='true'
                onClick={handleProfileMenuOpen}
                color='inherit'
              >
                <div
                  style={{
                    width: '1px',
                    backgroundColor: 'rgb(255 249 249 / 33%)',
                    height: '40px',
                    margin: '0 15px 0 0',
                  }}
                />
                <AccountCircle />
                <Typography style={{ marginLeft: '10px' }}>
                  {currentUser?.firstName} {currentUser?.lastName}
                </Typography>
              </IconButton>
            )}
        </div>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flex: 1,
          }}
        >
          <Container style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            minHeight: 'calc(100vh - 65px)',
            maxHeight: 'calc(100vh - 100px)',
            margin: 0,
            padding: 0
          }} maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            {props.children}
          </Container>
        </Box>
        {renderMenu}
      </Box>
      {alerts.length > 0 && (
          <div style={{background: 'white', position: 'fixed', bottom: '60px', left: '20px', right: '20px'}}>
            {currentUser && currentUser.clientId && alerts.map((a: Alert, key) => {
              return (
                <MuiAlert style={{zIndex: 2000}} key={key} severity={a.type} variant="outlined"
                  onClose={() => dispatch(removeAlert(a.id))}
                >
                  <AlertTitle className="capitalize">{a.type}</AlertTitle>
                  {a.message}
                </MuiAlert>
              )
            })}
          </div>
        )}
    </>
  );
}

export default DefaultAppContainer;